import React from "react";
import { SectionWrapper } from "./hoc";
import { useSelector } from "react-redux";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';





const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 600 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};

const Img = ({ data ,index}) => {
  return (
           
           
    <div draggable={false}  style={{placeContent:"center" , verticalAlign:'middle',}}  key={index}  className=" h-[500px] p-2  mb-10">
 
    <img  width='' height='' draggable={false} src={`https://demo.future-swift.com/pic/${data.src}`} alt={data.alt} 
   style={{objectFit:'contain'}}  className="rounded w-full max-h-[480px]" /> 
   
   
          </div>     
   
  );
};




const About_img = () => {


 const Images = useSelector((state) => state.cart.images);   


  return (
    <>
       <div  className=" m-auto px-[5%] w-[100%]  p-4  ">
  

    
    <Carousel
   // arrows={false}
    swipeable={true}
    showDots={true}
  //  customButtonGroup={<ButtonGroup />}
   // renderDotsOutside={true}
      responsive={responsive}
      ssr={true} // means to render carousel on server-side.
      infinite={true}
    autoPlay={true}
    
      autoPlaySpeed={3000}
    
  //arrows={false}
   
    >
        
{Images.map((item, index) => (
  
  Number(item.homescreen) > 0 ? 
         
         
         
         <Img
           key={`img_${index}`}
         data={item}
         index={index}
         />

         :null

       ))}
           

          
   
    
    
    </Carousel>
  
<br></br>
    
     




     </div>  

              
    </>
  );
};

export default SectionWrapper(About_img, "about_img");
